export const authenticatedSessionTextKey = 'MainLayout';

export type AuthenticatedSessionText = {
    Actions: {
        Home: string;
        CustomerSelector: string;
        UserProfile: string;
        ToggleSidebar: string;
        AskToEnable: string;
    };
    Sections: {
        Inventory: string;
        Services: string;
        Governance: string;
        Documents: string;
    };
    Navigation: {
        Applications: NavigationItemText;
        AzureTenants: NavigationItemText & DisabledNavigationItemText;
        Devices: NavigationItemText;
        Locations: NavigationItemText & DisabledNavigationItemText;
        MicrosoftLicenses: NavigationItemText & DisabledNavigationItemText;
        Network: NavigationItemText & DisabledNavigationItemText;
        AdvaniaServices: NavigationItemText;
        MicrosoftServices: NavigationItemText;
        Projects: NavigationItemText & DisabledNavigationItemText;
        ItClimate: NavigationItemText & DisabledNavigationItemText;
        ItFinancials: NavigationItemText & DisabledNavigationItemText;
        ItFinancialsV2: NavigationItemText;
        UserAccounts: NavigationItemText;
        UserGroups: NavigationItemText;
        ReleaseNotes: NavigationItemText;
        WikiArticles: NavigationItemText;
    };
    Mode: {
        Label: string;
        Customer: string;
        Internal: string;
        SwitchToCustomer: string;
        SwitchToInternal: string;
    };
    Internal: {
        Name: string;
        Description: string;
        Section: string;
        AiChat: string;
        AiChatTooltip: string;
        PricelistName: string;
        PricelistTooltip: string;
    };
};

type NavigationItemText = {
    Label: string;
    Tooltip: string;
};

type DisabledNavigationItemText = {
    Disabled: string;
};
